import React from 'react';

const Sidebar = ({ language }) => {
  const translations = {
    de: {
      sidebar_role: "Junior Penetration Tester",
      sidebar_contact_title: "Kontakt & Profile",
      sidebar_linkedin: "LinkedIn:",
      sidebar_email: "E-Mail:",
      sidebar_location: "Standort:",
      sidebar_location_value: "Wien, Österreich",
      sidebar_certs_title: "Zertifizierungen",
      sidebar_running: "laufend"
    },
    en: {
      sidebar_role: "Junior Penetration Tester",
      sidebar_contact_title: "Contact & Profiles",
      sidebar_linkedin: "LinkedIn:",
      sidebar_email: "Email:",
      sidebar_location: "Location:",
      sidebar_location_value: "Vienna, Austria",
      sidebar_certs_title: "Certifications",
      sidebar_running: "running"
    }
  };

  const t = translations[language];

  return (
    <aside className="sidebar">
      <p className="role"><strong>{t.sidebar_role}</strong></p>
      <h3>{t.sidebar_contact_title}</h3>
      <ul>
        <li><strong>{t.sidebar_linkedin}</strong> <a href="https://www.linkedin.com/in/elias-meisl-563050329">Elias Meisl</a></li>
        <li><strong>{t.sidebar_email}</strong> <a href="mailto:eliasmeisl02@gmail.com">eliasmeisl02@gmail.com</a></li>
        <li><strong>{t.sidebar_location}</strong> <span>{t.sidebar_location_value}</span></li>
      </ul>
      <h3>{t.sidebar_certs_title}</h3>
      <ul>
        <li> <a href="https://www.credly.com/badges/360877f7-0b60-4166-b685-922264944013/linked_in_profile"> CISCO Ethical Hacker</a> </li>
        <li>HTB CPTS [{t.sidebar_running}]<br/>(Certified Penetration Testing Specialist)</li>
      </ul>
    </aside>
  );
};

export default Sidebar;